export const Categories = () => {
    return {
        selected: false,
        opened: false,
        windowWidth: window.innerWidth,

        init () {
            this.opened = !this.isSm();
        },

        select(key) {

            this.selected = key;

            this.open(!this.isSm());

        },

        isOpen() {
            return this.opened;
        },

        openToggle() {
            this.opened = !this.opened;
        },

        open(open = true) {
            this.opened = open;
        },

        isSelected(key) {
            return this.selected === key;
        },

        isSm() {
            return window.innerWidth <= 1168
        }
    }
}
